module.exports = __webpack_public_path__ + "static/media/Chapter02.96ac6499.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/assets/Chapter02.jpg
// module id = 242
// module chunks = 0